import { I18nService, isDefined } from "@perxis-auto/shared";
import { selectFilterValues } from "../../../filterChoice/model/selectors/selectFilterValues.js";
import { APP } from "../../../../shared/config/app.js";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import { selectFilterGridItems } from "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import { selectSlice } from "../../../../shared/store/config/model/selectors/selectSlice.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import { getDependentFilterKeysByKey } from "../../lib/filterDependency/getDependentFilterKeysByKey.js";
import { prepareFilterItemProps } from "../../lib/filterItems/prepareFilterItemProps.js";
import { prepareFilterItemValue } from "../../lib/filterItems/prepareFilterItemValue.js";
const selectFilterItems = createAppSelector(
  [
    (_, { filterValuesItem }) => filterValuesItem,
    selectSlice,
    selectFilterGridItems,
    selectFilterValues
  ],
  (filterValuesItem, config, filterGridItems, filterValuesChoice) => {
    const { i18n } = I18nService.getInstance();
    const dependentFilterItemKeysMap = /* @__PURE__ */ new Map();
    const resetFilterItemKeysMap = /* @__PURE__ */ new Map();
    const extendedFilterGridItems = filterGridItems.map((item) => {
      var _a, _b;
      const filterValues = (_a = filterValuesItem == null ? void 0 : filterValuesItem.data) == null ? void 0 : _a[item.key];
      const props = prepareFilterItemProps(
        {
          type: item.type,
          props: item.props,
          filterValues
        },
        config
      );
      const value = prepareFilterItemValue({
        type: item.type,
        filterChoiceValue: filterValuesChoice == null ? void 0 : filterValuesChoice[item.key],
        filterValues
      });
      resetFilterItemKeysMap.set(item.key, getDependentFilterKeysByKey(item.key, filterGridItems));
      (_b = item == null ? void 0 : item.dependencies) == null ? void 0 : _b.forEach((dependentFilterItemKey) => {
        dependentFilterItemKeysMap.set(dependentFilterItemKey, [
          ...dependentFilterItemKeysMap.get(dependentFilterItemKey) || [],
          item.key
        ]);
      });
      return {
        ...item,
        props,
        value
      };
    });
    return extendedFilterGridItems.map(
      ({ key, path, type, props, value, dependencies, groupByKey, dependencyTextFormatter }) => {
        const dependentKeys = dependentFilterItemKeysMap.get(key);
        const dependentKeysSet = new Set(resetFilterItemKeysMap.get(key));
        dependentKeys == null ? void 0 : dependentKeys.forEach((key2) => dependentKeysSet.add(key2));
        const dependents = Array.from(dependentKeysSet.values());
        const dependentFilterItems = extendedFilterGridItems.filter(
          (filterItem) => dependencies == null ? void 0 : dependencies.includes(filterItem.key)
        );
        const unselectedDependentFilterItems = dependentFilterItems.filter((filterItem) => !isDefined(filterItem.value));
        const isDependencyFulfilled = !unselectedDependentFilterItems.length;
        const dependencyText = (dependencyTextFormatter == null ? void 0 : dependencyTextFormatter(unselectedDependentFilterItems)) ?? `${i18n.t("config.filterItem.dependencyText", { ns: APP.name })}`;
        const groupingFilterItem = extendedFilterGridItems.find((filterItem) => filterItem.key === groupByKey);
        const isGroupFulfilled = !!groupByKey && !!groupingFilterItem && isDefined(groupingFilterItem.value);
        return {
          key,
          path,
          value,
          type,
          props,
          dependents,
          dependencies,
          dependencyText,
          isDependencyFulfilled,
          groupByKey,
          isGroupFulfilled
        };
      }
    );
  }
);
export {
  selectFilterItems
};
